import { type PayoutPeriod } from "../../gql-generated/types";

export enum ProgramPayoutStatus {
    InProgress = "inProgress",
    Pending = "pending",
    Paid = "paid",
    // A payout record exists, but no score window confirms whether it has been paid.
    Recorded = "recorded",
    None = "none",
}

export interface LensScoreTotals {
    lensScore: number;
    subscriberActionsUu: number;
    subscribeCount: number;
}

export interface LensPlusPayoutRow {
    month: string;
    status: ProgramPayoutStatus;
    amountMilliUsd: number | null;
    // paidOn once paid, otherwise the expected payout date.
    payoutDate: string | null;
    // The score window's totals, else the month's Lens+ payout record.
    totals: LensScoreTotals | null;
}

export interface LensPlusEarnings {
    currentMonth: LensPlusPayoutRow;
    totalEarnedMilliUsd: number;
    paidMonths: { count: number; since: string } | null;
    payoutRows: LensPlusPayoutRow[];
}

export interface TopPerformerAward {
    month: string;
    amountMilliUsd: number;
    qualifiedPosters: number | null;
    paidOn: string | null;
}

export type PayoutPeriodAmount = Partial<
    Pick<
        PayoutPeriod,
        "period" | "totalAmountMilliUsd" | "payoutSubscriberActionsUu" | "payoutLensSubscribeCount" | "payoutLensScore"
    >
>;
